import React, { useEffect } from 'react';
import styles from './index.module.scss';
import { Box, Drawer } from '@mui/material';
import CloseGray from '@/assets/icons/closeGray.svg';

interface UKDrawerType {
  openDrawer: boolean; // 开关
  title?: string | React.ReactElement; // 标题
  width?: number | string; // 宽度
  height?: number | string; // 高度
  children: React.ReactNode; //子节点
  className?: string; // 抽屉样式
  showHeader?: boolean; // 显示头
  showTitle?: boolean; // 显示标题
  showCloseButton?: boolean; // 显示关闭按钮
  headerContentStyle?: React.CSSProperties; // 头部样式
  anchor?: 'left' | 'top' | 'right' | 'bottom' | undefined; // 抽屉位置
  handleClose: (e?: object, reason?: string) => void; // 关闭按钮回调
}

const UKDrawer = ({
  openDrawer,
  title,
  width,
  height,
  children,
  className,
  headerContentStyle,
  anchor = 'right',
  showHeader = true,
  showTitle = true,
  showCloseButton = true,
  handleClose,
}: UKDrawerType) => {
  useEffect(() => {
    if (openDrawer) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';

      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [openDrawer]);

  return (
    <Drawer
      open={openDrawer}
      anchor={anchor}
      className={className}
      disableScrollLock={true}
      onClose={handleClose}
      slotProps={{ backdrop: { sx: { touchAction: 'none' } } }}
    >
      <Box sx={BoxStyles(width, height)}>
        {showHeader && (
          <div className={styles.header} style={{ width }}>
            {showTitle && (
              <span className={styles.headerText} style={headerContentStyle}>
                {title}
              </span>
            )}
            {showCloseButton && (
              <button className={styles.headerButton} onClick={handleClose}>
                <CloseGray width={20} height={20} />
              </button>
            )}
          </div>
        )}
        <div style={{ overflowY: 'auto', flex: 1, paddingTop: '56px' }}>{children}</div>
      </Box>
    </Drawer>
  );
};

const BoxStyles = (width?: number | string, height?: number | string) => {
  return {
    display: 'flex',
    flexDirection: 'column',
    width: typeof width === 'string' ? width : `${width}px`,
    height: typeof height === 'string' ? height : `${height}px`,
  };
};

export default UKDrawer;
